import styled from "styled-components";

export const FormContainer = styled.div`
	.form {
		width: 100%;
		display: flex;
		height: 108px;
		padding: 20px;
	}
	.custom-select {
	}
	.btn-ctn {
		margin: auto 0px;
		width: 100%;
	}
	.cont-delete-icon {
		width: 15px;
		height: 15px;
	}
	.delete-icon-brochure {
		padding: 0px 5px;
		width: 15px;
		height: 15px;
		margin: 0 5px;
	}
	.error {
		.css-13cymwt-control {
			border-color: #ae1515;
		}
		color: #ae1515;
		&.text-area {
			border: 1px solid #ae1515;
			border-radius: 5px;
		}
	}
	.label-container {
		gap: 10xp;
	}
	.label-title {
		font-weight: 800;
	}
	.label-title-second {
		color: #666666;
		padding: 5px 0px;
	}
`;

export const Div = styled.div``;

export const InputChooseFile = styled.input``;

export const FileBorder = styled.div`
	height: auto;
	padding-top: 10px;
`;

export const FileLable = styled.label``;

export const FileName = styled.a``;
